import { useEffectOnlyOnce } from "../../../../../../../Common/utils/common";
import PaymentDrawTonightInterfaceStore from "../../interface/PaymentDrawTonightInterface";

const useDestructor = () => {
  useEffectOnlyOnce(() => () => {
    const { resetStore } = PaymentDrawTonightInterfaceStore.getState();
    resetStore();
  });
};

export default useDestructor;
